<template>
  <div class="main-content main-content_vertical">
    <div class="wrapper">
      <div v-if="inPayment">
        <div class="h1 h1-mob-lg">{{$t('subscriptions.payment_in_progress_please_wait')}}</div>
        <p>{{$t('subscriptions.after_the_transaction_you_will_be_automatically_redirected')}}</p>
        <div class="payment-status-block">
          <div class="progress progress-striped active">
            <div role="progressbar" class="progress-bar progress-bar-primary">
              <span> {{ $t('subscriptions.awaiting_payment') }} </span>
            </div>
          </div>
        </div>
        <div class="link-back-row">
          <router-link to="/" class="black-link">{{$t('sent.go_back')}}</router-link>
        </div>
      </div>
      <div v-else>
        <div class="h1 h1-mob-lg">{{$t('subscriptions.your_subscriptions')}}</div>
          <div class="current-subscription-block" v-if="subscription && paidTill">
            <subscription-info
              :subscription="subscription"
              :next-level="nextLevel" />
            <div class="payment-status-block-error" v-if="isPaymentMethodFailed">
              <p class="error" v-if="$store.getters.errorMessage"> {{ $store.getters.errorMessage }} </p>
              <button class="btn-orange" @click="subscribe" :disabled="$store.getters.subscriptionRequestInProgress">
                {{ $t('subscriptions.select_level') }}
              </button>
            </div>
            <div class="btns" v-else-if="isCanceled">
              <button class="btn-orange" @click="subscribe">
                {{ $t('subscriptions.subscribe_again') }}
              </button>
            </div>
            <div class="payment-status-block-error" v-else-if="lastRecurrentPaymentIsFailed">
              <p class="error" v-if="$store.getters.errorMessage"> {{ $store.getters.errorMessage }} </p>
              <p class="error" v-else>{{ $t('subscriptions.payment_failed_try_again') }}</p>
              <div class="btns">
                <button class="btn-orange" @click="payAgain" :disabled="$store.getters.subscriptionRequestInProgress">
                  {{ $t('subscriptions.try_again') }}
                </button>
                <button class="btn-orange" @click="subscribe" :disabled="$store.getters.subscriptionRequestInProgress">
                  {{ $t('subscriptions.change_level') }}
                </button>
              </div>
            </div>
            <div class="btns" v-else>
              <button class="btn-orange" @click="unsubscribe" :disabled="$store.getters.subscriptionRequestInProgress">
                {{ $t('subscriptions.unsubscribe') }}
              </button>
              <button class="btn-orange" @click="subscribe" :disabled="$store.getters.subscriptionRequestInProgress">
                {{ $t('subscriptions.change_level') }}
              </button>
            </div>
          </div>
          <div class="no-subscription-block" v-else>
            <div>{{$t('subscriptions.no_subscription')}}</div>
            <div class="btns">
              <button class="btn-orange" @click="subscribe">
                {{ $t('subscriptions.select_level') }}
              </button>
            </div>
          </div>
          <router-link to="/" class="black-link">{{$t('sent.go_back')}}</router-link>
        </div>
      </div>
  </div>
</template>
<script>

import SubscriptionInfo from "../components/SubscriptionInfo.vue";
import SubscriptionPaymentMethodStatus from "../store/models/SubscriptionPaymentMethodStatus";
import SubscriptionStatus from "../store/models/SubscriptionStatus";

export default {
  name: "Subscriptions",
  components: {
    'subscription-info': SubscriptionInfo,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.$store.getters.authenticated) {
        next('/');
      } else {
        next();
      }
    });
  },
  computed: {
    isPaymentMethodFailed() {
      return this.$store.getters.subscriptionPaymentMethodStatus === SubscriptionPaymentMethodStatus.Failed;
    },
    inPayment() {
      return this.$store.getters.currentSubscription?.inPayment;
    },
    subscription() {
      return this.$store.getters.currentSubscription;
    },
    downgradePlanned() {
      return this.$store.getters.downgradePlanned;
    },
    nextLevel() {
      return this.$store.getters.nextLevel;
    },
    isCanceled() {
      return this.$store.getters.currentSubscription? !this.$store.getters.currentSubscription.recurrent && this.$store.getters.currentSubscription.nextRecurrentPayment == null && this.$store.getters.currentSubscription.nextLevel == null : false;
    },
    paidTill() {
      return this.subscription? this.subscription.paidTill : null
    },
    lastRecurrentPaymentIsFailed() {
      return this.subscription?.lastFailedPaymentAttempt != null;
    },
  },
  methods: {
    unsubscribe() {
      this.$router.push({ name: 'Unsubscribe' });
    },
    subscribe() {
      this.$router.push({ name: 'SubscriptionsSelector' });
    },
    payAgain() {
      this.$store.dispatch('paySubscription');
    },
  },
};
</script>
<style lang="scss">
  .btns {
    display: flex !important;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 20px;
    max-width: 640px;
  }
  .text-error {
    color: red !important;
    margin-top: 20px;
  }
  .progress-bar {
    background-color: #2196F3;
    box-shadow:none;
    width: 100%;
    height: auto;
    span{
      top: 25%;
      position: relative;
      color: #f5f5f5;
      font-weight: 500;
    }
  }
  .payment-status-block-error {
    margin-top: 30px;
    margin-bottom: 30px;
    .error {
      color: #ff0000;
      margin-bottom: 20px;
    }
  }
</style>
